/**
 * レセプト内容一覧 — init hook.
 * Loads defaults + insurer_types + ini_options for the search form.
 */

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import useAppToast from '@/hooks/useAppToast';
import { useClinicContext } from '@/hooks/main/useClinicContext';
import { DEFAULT_FETCH_ERROR_MESSAGE, getApiErrorMessage } from '@/utils/apiError';
import { getRezeptHistoriesInit } from '@/services/main/rezeptHistories';
import type { RezeptHistoriesInitResponse } from '@/pages/main/rezeptHistories/types';

export const useRezeptHistoriesInit = () => {
  const { tenant, clinicNumber } = useClinicContext();
  const toast = useAppToast();

  const { data, isLoading, isError, error } = useQuery<RezeptHistoriesInitResponse, Error>({
    queryKey: ['rezept-histories', 'init', tenant, clinicNumber],
    queryFn: () => getRezeptHistoriesInit(tenant, clinicNumber),
    enabled: !!tenant && !!clinicNumber,
    staleTime: 5 * 60_000,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading };
};
